<!-- header -->
<app-header *ngIf="!frontend"></app-header>
<!-- end header -->

<!-- Content -->
<div class="w-full" *ngIf="!frontend">
  <div class="p-4 sm:p-6 space-y-4 sm:space-y-6">

    <!-- Grid -->
    <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS BOL</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a [queryParams]="{ app: 'bol-validation-tool' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To BOL
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS CASH</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a href="/dashboard"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To CASH
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS GRES</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a [queryParams]="{ app: 'res' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To GRES
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS BILLER</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>

          <a [queryParams]="{ app: 'biller' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To BILLER
          </a>
        </div>
      </div>
      <!-- End Card -->

    </div>
    <!-- End Grid -->


    <!-- Grid -->
    <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS CTTUM</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a href="/dashboard"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To CTTUM
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS TRADE</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a [queryParams]="{ app: 'trade' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To TRADE
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS BANCASSURANCE</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>
          <a [queryParams]="{ app: 'bancassurance' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To BANCASSURANCE
          </a>
        </div>
      </div>
      <!-- End Card -->

      <!-- Card -->
      <div
        class="lex flex-col bg-white border border-gray-200 shadow-2xs rounded-xl  ">
        <div class="flex justify-center items-center h-40">
          <img src="images/logo.png" alt="Cardiology Department" class="w-40 h-40 object-cover">
        </div>
        <div class="p-4">
          <h3 class="text-xl font-bold mb-2">CIMS PAPSS</h3>
          <p class="text-sm text-gray-600 mb-4">
            A place where our customers come first, offering smart solutions and value, where we believe in being at the
            forefront of useful innovation for convenience.
          </p>

          <div class="text-sm text-gray-700 mb-4">
            <span>Click button below to go to app</span>
          </div>

          <a [queryParams]="{ app: 'papss' }" [routerLink]="['/cims']"
            class="block w-full text-center px-4 py-2 bg-[#0d3576] text-white rounded-lg hover:bg-blue-600">
            Navigate To PAPSS
          </a>
        </div>
      </div>
      <!-- End Card -->

    </div>
    <!-- End Grid -->

  </div>
</div>

<iframe #iframeRef *ngIf="frontend && frontend === 'biller'"
  src="https://biller.dev.afs1-nprd.aws-ug.sbgrp.cloud" width="100%" class="h-screen"
  sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"></iframe>

<iframe #iframeRef *ngIf="frontend && frontend === 'bol-validation-tool'"
  src="https://wa-sbuga-bolvalidationfrontend-nonprod.azurewebsites.net/redirect" width="100%" class="h-screen"
  sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-modals allow-popups" allow-scripts="true" ></iframe>

  <!-- <iframe #iframeRef *ngIf="frontend && frontend === 'res'"
  src="https://wa-sbuga-cimsresfrontend-nonprod.azurewebsites.net/redirect/" width="100%" class="h-screen"
  sandbox="allow-forms allow-scripts allow-same-origin allow-downloads"></iframe> -->

  <iframe #iframeRef *ngIf="frontend && frontend === 'papss'"
  [src]="iframeSrc" width="100%" class="h-screen"></iframe>

<iframe #iframeRef *ngIf="frontend && frontend === 'bancassurance'"
  src="https://biller.dev.afs1-nprd.aws-ug.sbgrp.cloud:8443/" width="100%" class="h-screen"
  sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"></iframe>
  
  <!-- sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-modals allow-popups" allow-scripts="true"  -->

  <iframe #iframeRef *ngIf="frontend && frontend === 'res'"
  src="https://wa-sbuga-cimsresfrontend-nonprod.azurewebsites.net/redirect/" width="100%" class="h-screen"
  ></iframe>

  <!-- sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation" -->

  <iframe #iframeRef *ngIf="frontend && frontend === 'trade'"
  src="https://wa-sbuga-cimstradefrontend-nonprod.azurewebsites.net/redirect/" width="100%" class="h-screen"
  ></iframe>
